import { render, staticRenderFns } from "./manage-settings.vue?vue&type=template&id=5cbf36e7"
import script from "./manage-settings.vue?vue&type=script&lang=js"
export * from "./manage-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports